import { IAssetPurchaseOrder, IProjectInstallation, ISiteReccee } from '@api/models';
import { Button, Drawer } from '@hyperflake/react-ui-library';
import { Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'httpConfig/http';
import { getResellerIdFromRedux } from 'modules/shared/helpers/shared.utils';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface IDeleteAssetPurchaseOrderDrawerProps {
    open: boolean;
    onClose: () => void;
    clientInstallationId: string;
    projectInstallationId: string;
    assetPurchaseOrder: IAssetPurchaseOrder | null;
}

const DeleteAssetPurchaseOrderDrawer = (props: IDeleteAssetPurchaseOrderDrawerProps) => {
    const { clientInstallationId, projectInstallationId, open, onClose, assetPurchaseOrder } = props;
    // const { clientInstaId } = useParams();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const deletePurchaseOrderMutation = useMutation(async (payload: any) => {
        const { data, status } = await http.delete(
            `${
                import.meta.env.VITE_APP_API_URL
            }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/asset-purchase-order/${
                assetPurchaseOrder._id
            }`
        );
        return { data, status };
    });

    const handleDelete = async () => {
        if (assetPurchaseOrder === null) return onClose();
        try {
            const { data, status } = await deletePurchaseOrderMutation.mutateAsync({
                id: assetPurchaseOrder._id,
            });
            console.log({ data, status });
            toast.success('Purchase Order Deleted Successfully.');
            // queryClient.setQueryData<IClientInstallation[]>(['client-installations'], (prev) => {
            //     if (!prev) return;

            //     const index = prev.findIndex((c) => c._id === clientInstallation._id);
            //     return produce(prev, (draft) => {
            //         draft.splice(index, 1);
            //         return draft;
            //     });
            // });
            onClose();
            navigate(
                `/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/purchase-order`
            );
        } catch (ex: any) {
            onClose();
            console.log(ex.status);
            if (ex.status === 400) {
                toast.error(ex.data.message);
            } else {
                toast.error(ex?.data?.message || 'Some error occured, please try again.');
                console.log(ex);
            }
        }
    };

    return (
        <Drawer open={open} onClose={onClose} title="Confirm Delete">
            <div>
                <div>
                    <Label className="mt-8 inline-block">
                        The following Purchase Order &ldquo;
                        <span className="font-bold">{assetPurchaseOrder?._id}</span>&rdquo; will be deleted.
                    </Label>

                    <div className="flex gap-2 mt-2">
                        <Button
                            disabled={deletePurchaseOrderMutation.isLoading}
                            onClick={() => onClose()}
                            variant="default"
                            color={'primary'}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={deletePurchaseOrderMutation.isLoading}
                            className="w-20"
                            onClick={() => handleDelete()}
                            variant="default"
                            color={'danger'}
                        >
                            {deletePurchaseOrderMutation.isLoading ? <CircularProgress size={18} /> : 'Delete'}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default DeleteAssetPurchaseOrderDrawer;
